
import { Utils } from "../../../../../services/utils.service";
import { DataCollection } from "../../../../infrastructure/datacollection";
import { DataContainerService } from "../../../../infrastructure/datacontainer.service";
import { RequestTypes } from "../../../../infrastructure/enums";
import { TransportData } from "../../../../infrastructure/transportdata";

export class NotificationRecordsFetchRequest {
    public static readonly FetchRequestType: string = "notification_records_fetch_request";
  employee_record_ids: number[] = [];
  page_number: number = 0;
    public MergeIntoTransportData = (td: TransportData) => {
        let coll = DataContainerService.GetInstance().GetOrCreateCollection(td.MainData, NotificationRecordsFetchRequest.FetchRequestType) as DataCollection;
        coll.Entries.push(this);
    }

    public FormulateTransportData = () => {
        let td = Utils.GetInstance().CreateNewTransportData(RequestTypes.Fetch);
        this.MergeIntoTransportData(td);

        return td;
    }
}

